export const courseValidation = ({ selectorValue, setCourseStatusError }) => {
  let isValid = true;

  if (!selectorValue) {
    setCourseStatusError("Нельзя сохранить пустой курс");
    isValid = false;
  }
  if (selectorValue && !selectorValue.course) {
    setCourseStatusError("Нужно выбрать Курс");
    isValid = false;
  }
  if (selectorValue && !selectorValue.status) {
    setCourseStatusError("Нужно выбрать Статус");
    isValid = false;
  }
  return isValid;
};
